'use client';

import { createContext } from 'react';

import type { PopStoreExtendedSubscriptionLevel } from '@ps/models/lib/creator-subscription';

/** The facts needed to open the in-place subscribe picker for a creator. */
export interface OpenSubscribeInput {
  /** Creator store id (profile doc id) to subscribe to. */
  creatorId: string;
  /** Preselect a tier. */
  defaultLevel?: PopStoreExtendedSubscriptionLevel;
  /** Minimum selectable tier. */
  minLevel?: PopStoreExtendedSubscriptionLevel;
}

export interface SubscribeModalContextValue {
  openSubscribe: (input: OpenSubscribeInput) => void;
}

export const SubscribeModalContext =
  createContext<SubscribeModalContextValue | null>(null);
